angular.module( 'acme.view.application.sherpa.activities', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.sherpa.activities.controllers',
  'acme.view.application.sherpa.activities.tenant',
  'acme.view.application.sherpa.activities.customer'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var sherpaActivities = {
        name: 'application.sherpa.activities',
        url: '/activities',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'SherpaActivitiesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/sherpa/activities/activities.tpl.html'
          }
        },
        data: {
          pageTitle: 'CSR Activities',
          permissions: ['CSM']
        }
      };

    $stateProvider
      .state(sherpaActivities);
});
